import React, { ReactNode } from 'react';
import BaseButton from '@material-ui/core/Button';
import makeStyles from '@material-ui/core/styles/makeStyles';

interface Props {
  color?: any;
  doubleAngle?: any;
  className?: any;
  onClick?: any;
  empty?: boolean;
  disabled?: boolean;
  type?: 'submit' | 'reset' | 'button';
  startIcon?: ReactNode;
}

const useStyles = makeStyles({
  root: {
    minHeight: 40,
    height: 40,
    padding: 0,
    fontSize: 16,
  },
});

const Button: React.FC<Props> = ({
  children,
  color,
  doubleAngle,
  onClick,
  empty,
  className,
  type,
  startIcon,
  ...rest
}) => {
  const classes = useStyles();
  return (
    <BaseButton
      variant={empty ? 'outlined' : 'contained'}
      color={color}
      classes={{ root: classes.root }}
      fullWidth
      onClick={onClick}
      className={className}
      type={type}
      startIcon={startIcon}
      disableRipple
      {...rest}
    >
      {doubleAngle && color === 'secondary' && `${String.fromCharCode(171)} `}
      {children}
      {doubleAngle && color === 'primary' && ` ${String.fromCharCode(187)}`}
    </BaseButton>
  );
};

Button.defaultProps = {
  color: 'primary',
  doubleAngle: true,
  empty: false,
};

export default Button;
